import { render, staticRenderFns } from "./AutoTransfer.vue?vue&type=template&id=0ca971f6&scoped=true"
import script from "./AutoTransfer.vue?vue&type=script&lang=js"
export * from "./AutoTransfer.vue?vue&type=script&lang=js"
import style0 from "./AutoTransfer.vue?vue&type=style&index=0&id=0ca971f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca971f6",
  null
  
)

export default component.exports